import { ServerError } from "@/components";

export function Page500() {
  return <ServerError />;
}
